import axios from 'axios';

const isLocal =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

const baseURL = isLocal ? 'http://localhost:8000/' : '/';

const api = axios.create({
  baseURL,
  withCredentials: true,
});

// Fungsi untuk ambil CSRF token
export const getCsrfToken = () => api.get('/sanctum/csrf-cookie');

export default api;
